import { Group } from "@mantine/core";
import { Button } from "../ui/Button";
import {
  useActiveAssignment,
  useUserAssignmentResultStatus,
  useUserIncompleteAssignment,
} from "@/store/selectors/assignmentSelectors";
import { useIsLaptopOrBigger } from "@/styles/useStyles";
import { Text } from "../ui/Text";
import { Navigation } from "@/services/Navigation";
import logo from "@/assets/advize-logo.webp";
import { Image } from "../ui/Image";
import { useMemo } from "react";
import { useActiveUserPartner } from "@/store/selectors";
import { PartnerLogo } from "../PartnerLogo";

export const AssignmentHeader = () => {
  const activeAssignment = useActiveAssignment();
  const userIncompleteAssignment = useUserIncompleteAssignment();
  const isLaptopOrBigger = useIsLaptopOrBigger();
  const userAssignmentResultStatus = useUserAssignmentResultStatus();
  const activeUserPartner = useActiveUserPartner();

  const AssignmentStatusText = useMemo(() => {
    if (userAssignmentResultStatus?.minutesLeftToWatch) {
      return `Watch ~${Math.round(userAssignmentResultStatus?.minutesLeftToWatch)} more minutes`;
    }

    if (
      userAssignmentResultStatus?.responsesLeftToComplete &&
      userAssignmentResultStatus?.responsesLeftToComplete > 0
    ) {
      return `Respond to ${userAssignmentResultStatus?.responsesLeftToComplete} more reflection question${userAssignmentResultStatus?.responsesLeftToComplete > 1 ? "s" : ""}`;
    }

    return null;
  }, [
    userAssignmentResultStatus?.minutesLeftToWatch,
    userAssignmentResultStatus?.responsesLeftToComplete,
  ]);

  return (
    <Group align="center" h="100%" px="lg" justify="space-between" flex={1}>
      <Group gap="xs" style={{ flex: 1 }}>
        {/* <AssignmentIcon size={28} color={theme.colors.text[0]} /> */}
        <Button unstyled onClick={() => Navigation.navigate("/")}>
          {activeUserPartner ? (
            <PartnerLogo width={34} partnerId={activeUserPartner?.id} noLink />
          ) : (
            <Image
              src={logo}
              w={isLaptopOrBigger ? 34 : 26}
              mb={2}
              alt="Advize logo"
            />
          )}
        </Button>
        <a
          style={{ flex: 1 }}
          onClick={() => {
            Navigation.navigate(`/assignments/${activeAssignment?.id}`);
          }}
        >
          <Text
            titleStyle={activeAssignment?.title ? "h4" : "h3"}
            c="text.1"
            lh={1}
            pt={2}
            lineClamp={1}
          >
            {activeAssignment?.title || "advize"}
          </Text>
        </a>
      </Group>
      <Group gap="md">
        {isLaptopOrBigger && (
          <Text size="sm" c="text.1">
            {AssignmentStatusText}
          </Text>
        )}
        <Button
          variant="light"
          color="primary.0"
          size={isLaptopOrBigger ? "sm" : "xs"}
          radius="xl"
          onClick={() => {
            Navigation.navigate(
              `/assignments/${userIncompleteAssignment ? userIncompleteAssignment?.id : activeAssignment?.id}`,
            );
          }}
        >
          {isLaptopOrBigger ? "Back to Assignment" : "Back"}
        </Button>
      </Group>

      {/* <div /> */}
    </Group>
  );
};
